import React from 'react'
import { seperatorClassMap } from 'AccountsUtils'
import SVGComponent from './SVGComponent'

const SectionBlock = ({
  header,
  subHeader,
  children,
  isPWA = true,
  customHeadClass = null,
  secondaryText = null,
  onSecondaryClick,
  secondaryType = 'text',
  customBodyClass = null,
  isRelative = false,
  suffix,
  fareType,
  subHeaderText = false,
  isBottomMargin = false,
  bgColor = false,
  // eslint-disable-next-line no-nested-ternary
  seperatorClass = isPWA ? '' : isRelative ? '' : seperatorClassMap.non_relative
}) => (
  <section style={{ WebkitUserSelect: 'auto', userSelect: 'auto' }} className={`${!isPWA ? ' ba br-4' : ''} ${seperatorClass}`}>
    <div
      style={{ WebkitUserSelect: 'auto', userSelect: 'auto' }}
      className={`${customHeadClass ||
        (!isPWA ?
          `fs-body-3 fw-600 ${bgColor ? 'bg-white' : 'bg-white-f7'
          } px-4 py-3 flex flex-between flex-middle` :
          'pwa-section-header border-bottom-grey')} tt-first-caps`}
    >
      <div className="flex flex-column" style={{ WebkitUserSelect: 'auto', userSelect: 'auto' }}>
        <If condition={header}>
          <div className="flex" style={{ WebkitUserSelect: 'auto', userSelect: 'auto' }}>
            <h1 className="fs-5" style={{ WebkitUserSelect: 'auto', userSelect: 'auto' }}>{header}</h1>
            <If condition={subHeaderText}>
              <If condition={secondaryType === 'text'}>
                <span
                  className="c-blue tt-lowercase fs-caption-2 pl-2 fs-11 fw-500 us-text pointer lh-31"
                  onClick={onSecondaryClick}
                >
                  {subHeaderText}
                </span>
                <Else />
                <button
                  className="btn bg-blue c-white px-4 py-2 bn br-4"
                  type="button"
                  onClick={onSecondaryClick}
                >
                  {subHeaderText}
                </button>
              </If>
            </If>
          </div>
        </If>
        <If condition={subHeader}>
          <h2>{subHeader}</h2>
        </If>
      </div>
      <If condition={secondaryText}>
        <If condition={secondaryType === 'text'}>
          <p className="tt-lowercase" onClick={onSecondaryClick}>
            {secondaryText}
          </p>
          <Else />
          <button
            className="btn bg-blue c-white px-4 py-2 bn br-4 fs-12"
            type="button"
            onClick={onSecondaryClick}
          >
            {secondaryText}
          </button>
        </If>
      </If>
      <If condition={suffix}>
        <div className="flex flex-1 pl-2 fs-10" style={{ WebkitUserSelect: 'auto', userSelect: 'auto' }}>
          <div className="" style={{ WebkitUserSelect: 'auto', userSelect: 'auto' }}>
            <p className="red-status red-status summaryBadge" style={{ WebkitUserSelect: 'auto', userSelect: 'auto' }}>{suffix}</p>
          </div>
        </div>
      </If>
      <If condition={fareType}>
        <div className={`flex flex-1 pl-2 fs-10 ${!isPWA && 'pt-2'}`} style={{ WebkitUserSelect: 'auto', userSelect: 'auto' }}>
          <div className="" style={{ WebkitUserSelect: 'auto', userSelect: 'auto' }}>
            {fareType === 'EZCANCEL' || fareType === 'FLEXIPLUS' && fareType === 'FLEXIFLY' && <SVGComponent svgIcon={fareType.toUpperCase()} />}
          </div>
        </div>
      </If>
    </div>
    <If condition={children}>
      <div className={`${isBottomMargin ? '' : 'bg-white'} ${customBodyClass || ''}`} style={{ WebkitUserSelect: 'auto', userSelect: 'auto' }}>
        {children}
      </div>
    </If>
  </section>
)

export default SectionBlock
